import Vue from 'vue'
import numeral from 'numeral'
import moment from 'moment'

Vue.filter('formatStatus', (status) => {
  if (!status) { return }
  const status_new = status.toUpperCase()
  switch (status_new) {
    case 'DOCTOR_END_CALL': return 'SUKSES'
    case 'PATIENT_END_CALL': return 'SUKSES'
    case 'COMPLETED': return 'SUKSES'
    case 'CANCELLED': return 'DIBATALKAN'
    case 'TIME_OUT': return 'SUKSES'
    case 'DOCTOR_ACCIDENT': return 'SUKSES'
    case 'PATIENT_ACCIDENT': return 'SUKSES'
    case 'RATING': return 'SUKSES'

    case 'PATIENT_NO_ANSWER': return 'GAGAL PASIEN'
    case 'PATIENT_MISSED_CALL': return 'GAGAL PASIEN'
    case 'PATIENT_REJECT': return 'PASIEN TOLAK PANGGILAN'

    case 'DOCTOR_NO_ANSWER': return 'GAGAL DOKTER '
    case 'BOTH_NO_ANSWER': return 'GAGAL DOKTER'
    case 'UNFINISHED': return 'GAGAL RANGKUMAN'
    case 'UNFINISHED_SUMMARY' : return 'GAGAL RANGKUMAN'
  }

  return status_new.replace(/[_-]/g, ' ')
})

Vue.filter('formatMoney', (value) => {
  return numeral(value).format('0,0')
})

Vue.filter('formatDateEpoch', (value, format = 'YYYY-MM-DD') => {
  return moment.unix(value).format(format)
})

Vue.directive('click-outside', {
  bind (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
